import { SupportedEvents } from '@/features/webengage/types'
import { sendWebengageEvent } from '@/features/webengage/utils'

import { eventBus } from '../bus'
import { convertToFavoriteData } from '../utils'

export function registerWebengageSubscribers(events: Set<string>) {
    if (events.has(SupportedEvents.add_to_favorite)) {
        eventBus.subscribe('favorite.added', (payload) => {
            const data = convertToFavoriteData(payload, { truncateProductName: true })
            sendWebengageEvent(SupportedEvents.add_to_favorite, data)
        })
    }

    if (events.has(SupportedEvents.remove_from_favorite)) {
        eventBus.subscribe('favorite.removed', (payload) => {
            const data = convertToFavoriteData(payload, { truncateProductName: true })
            sendWebengageEvent(SupportedEvents.remove_from_favorite, data)
        })
    }
}
